import { Icon } from './icons';

/** 导航项 */
export interface NavItem {
  /** 路由路径 (同时作为高亮匹配前缀) */
  path: string;
  /** 显示名 */
  label: string;
  /** SVG 字符串 */
  icon: string;
}

/** 导航分组 */
export interface NavGroup {
  /** 分组标题 (同时用于顶栏 "分组 / 页面标题") */
  label: string;
  /** 分组内导航项 */
  items: NavItem[];
}

/** 侧栏 / 抽屉导航分组 */
export const NAV_GROUPS: NavGroup[] = [
  {
    label: '日常接待',
    items: [
      { path: '/', label: '今日总览', icon: Icon.Dashboard },
      { path: '/tasks', label: '任务', icon: Icon.Tasks },
      { path: '/bind', label: '绑定中心', icon: Icon.Link },
      { path: '/invite', label: '邀请填表', icon: Icon.Invite },
      { path: '/customer-feedback', label: '客户反馈', icon: Icon.Inbox },
      { path: '/dispatch', label: '接客员调度', icon: Icon.Staff },
      { path: '/push', label: '今日总览图', icon: Icon.Push },
    ],
  },
  {
    label: '商品',
    items: [
      { path: '/products', label: '商品管理', icon: Icon.Box },
      { path: '/xianyu-listings', label: '闲鱼链接', icon: Icon.Store },
      { path: '/share-product', label: '群发商品', icon: Icon.Share },
      { path: '/custom-quotes', label: '自定义报价单', icon: Icon.Receipt },
    ],
  },
  {
    label: '营销',
    items: [
      { path: '/price-plans', label: '价格策略', icon: Icon.Tag },
      { path: '/coupons', label: '优惠券', icon: Icon.Coupon },
      { path: '/banners', label: '活动横幅', icon: Icon.Picture },
      { path: '/season-events', label: '季节活动', icon: Icon.Calendar },
      { path: '/image-reviews', label: '图片审核', icon: Icon.Picture },
    ],
  },
  {
    label: '会员与钱包',
    items: [
      { path: '/customer-tiers', label: '会员等级', icon: Icon.Crown },
      { path: '/tier-benefits', label: '会员权益', icon: Icon.Gift },
      { path: '/mini-program-users', label: '小程序用户', icon: Icon.Group },
      { path: '/recharge-plans', label: '充值档位', icon: Icon.Wallet },
      { path: '/payments-trace', label: '支付追溯', icon: Icon.Card },
      { path: '/refund-requests', label: '退款审批', icon: Icon.Refund },
    ],
  },
  {
    label: '系统设置',
    items: [
      { path: '/gold-price', label: '金价管理', icon: Icon.Coin },
      { path: '/api-tokens', label: 'API 令牌', icon: Icon.Key },
      { path: '/client-errors', label: '客户端错误', icon: Icon.Bell },
      { path: '/workbench-download', label: '工作台安装包', icon: Icon.Download },
    ],
  },
];

/** 手机底部 Tab (最后一个 "菜单" 由 AppShell 单独渲染) */
export const MOBILE_TABS: NavItem[] = [
  { path: '/', label: '总览', icon: Icon.Dashboard },
  { path: '/tasks', label: '任务', icon: Icon.Tasks },
  { path: '/bind', label: '绑定', icon: Icon.Link },
  { path: '/products', label: '商品', icon: Icon.Box },
];

/** 按路径找到当前所属导航项与分组 (最长前缀匹配, "/" 只精确匹配) */
export function matchNav(path: string): { group: NavGroup; item: NavItem } | null {
  let best: { group: NavGroup; item: NavItem } | null = null;
  for (const group of NAV_GROUPS) {
    for (const item of group.items) {
      const hit = item.path === '/'
        ? path === '/'
        : path === item.path || path.startsWith(`${item.path}/`);
      if (hit && (!best || item.path.length > best.item.path.length)) best = { group, item };
    }
  }
  return best;
}
